import { create } from 'zustand'
import { immer } from 'zustand/middleware/immer'
import { persist } from 'zustand/middleware'
import { userInfo } from 'os'

interface RememberPhoneOptions {
  phone: string
  phonePassword: string
  areaCode: string
  remember: boolean
}
interface RememberEmailOptions {
  email: string
  emailPassword: string
  remember: boolean
}
interface UserInfo {
  area_code: string
  avatar: string
  can_use_google: boolean
  company_code: string
  email: string | null
  emp: string
  emp_name: string
  enterprise_auth: number
  enterprise_code: string
  is_admin: number
  mobile: string
  name: string
  prefix: string
  prefix_name: string
  sex: number
  system_run_day: number
  token: string
  user_id: number
  user_name: string
}
interface PersistData {
  lang: 'en_US' | 'zh_CN'
  rememberPhoneOptions: RememberPhoneOptions
  rememberEmailOptions: RememberEmailOptions
  userInfo: UserInfo
  expireTime: number
  isLogin: boolean
}

interface PersistDataActions {
  setLang: (lang: 'en_US' | 'zh_CN') => void
  setRememberPhoneOptions: (options: RememberPhoneOptions) => void
  setRememberEmailOptions: (options: RememberEmailOptions) => void
  setUserInfo: (userInfo: UserInfo) => void
  logIn: (userInfo: UserInfo) => void
  logOut: () => void
}

const usePersistDataStore = create<PersistData & PersistDataActions>()(
  persist(
    immer((set) => ({
      lang: 'en_US',
      rememberPhoneOptions: {
        phone: '',
        phonePassword: '',
        areaCode: '+61',
        remember: false,
      },
      rememberEmailOptions: {
        email: '',
        emailPassword: '',
        remember: false,
      },
      userInfo: {
        area_code: '',
        avatar: '',
        can_use_google: false,
        company_code: '',
        email: null,
        emp: '',
        emp_name: '',
        enterprise_auth: 0,
        enterprise_code: '',
        is_admin: 0,
        mobile: '',
        name: '',
        prefix: '',
        prefix_name: '',
        sex: 0,
        system_run_day: 0,
        token: '',
        user_id: 0,
        user_name: '',
      },
      expireTime: 0,
      isLogin: false,

      setLang: (lang: 'en_US' | 'zh_CN') => {
        set((state) => {
          state.lang = lang
        })
      },
      setRememberPhoneOptions: (options: RememberPhoneOptions) => {
        set((state) => {
          state.rememberPhoneOptions = options
        })
      },
      setRememberEmailOptions: (options: RememberEmailOptions) => {
        set((state) => {
          state.rememberEmailOptions = options
        })
      },
      setUserInfo: (userInfo: UserInfo) => {
        set((state) => {
          state.userInfo = userInfo
        })
      },
      logIn: (userInfo: UserInfo) => {
        set((state) => {
          state.userInfo = userInfo
          state.isLogin = true
          state.expireTime = Date.now() + 1000 * 60 * 60 * 24 * 7
        })
      },
      logOut: () => {
        set((state) => {
          state.isLogin = false
          state.expireTime = 0
          state.userInfo = {
            area_code: '',
            avatar: '',
            can_use_google: false,
            company_code: '',
            email: null,
            emp: '',
            emp_name: '',
            enterprise_auth: 0,
            enterprise_code: '',
            is_admin: 0,
            mobile: '',
            name: '',
            prefix: '',
            prefix_name: '',
            sex: 0,
            system_run_day: 0,
            token: '',
            user_id: 0,
            user_name: '',
          }
        })
      },
    })),
    { name: 'basket' }
  )
)

export default usePersistDataStore
